import {ScrollArea} from '@components/ui/scroll-area/ScrollArea.tsx'
import {Scrollbar} from '@components/ui/scrollbar/Scrollbar.tsx'
import {UserDetailsAvailabilitySection} from '@/features/users-availability/components/UserDetailsAvailabilitySection'
import {useRef} from 'react'
import {useGetUser} from '@/features/users/queries/useGetUser.ts'
import {Spinner} from '@components/ui/spinner/Spinner.tsx'
import {ErrorBox} from '@components/commons/error-box/ErrorBox.tsx'
import {AlertCircleIcon} from '@components/ui/icon/Icon.tsx'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {useURLParsedParams} from '@/hooks/useURLParsedParams'
import {UserDetailsUrlParams} from '@/types'

export const UserDetailsAvailability = ({userId}: {userId?: string}) => {
    const viewportRef = useRef<HTMLDivElement>(null)
    const id = useURLParsedParams(UserDetailsUrlParams)

    const userQuery = useGetUser({
        userId: id.success ? id.data.id : userId,
        responseType: 'extended',
        options: {enabled: !!id.success || !!userId}
    })

    if (!userId && !id.success) {
        return <ErrorBox icon={<AlertCircleIcon />} title="No authenticated user found" />
    }

    if (userQuery.isPending) {
        return (
            <Flexbox justify="center" align="center" style={{height: '200px'}}>
                <Spinner size={32} />
            </Flexbox>
        )
    }

    if (userQuery.isError || !userQuery.data) {
        return <ErrorBox icon={<AlertCircleIcon />} title="Failed to load user data" />
    }

    return (
        <ScrollArea scrollbar={<Scrollbar />} viewportProps={{ref: viewportRef}}>
            <UserDetailsAvailabilitySection user={userQuery.data} />
        </ScrollArea>
    )
}
